import script from "./AjudaIconComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AjudaIconComponent.vue?vue&type=script&setup=true&lang=js"

import "./AjudaIconComponent.vue?vue&type=style&index=0&id=680313a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-680313a3"]])

export default __exports__